module.exports = __webpack_public_path__ + "media/components/Influencers/FormTags/Categories/28-b9e05dba98e05c05ac2aefada3ae8f6f.png";